import React from 'react';
import { Icons, IconButton } from "@curves/ui-base";
import useDocumentApi from '@apis/useDocumentApi';
import { objectToQueryString } from '@util/utils';

const InBodyMultipleInformationDialog = (props) => {
    const { sourceData = {} } = props;
    const { getMultipleInformationApi } = useDocumentApi();

    const handleMultipleInformation = () => {
        const { measureID, memberID, ...other } = sourceData;
        doMultipleInformationApi(
            {
                memberID,
                ...other,
            },
            measureID,
            memberID
        );
    };

    const doMultipleInformationApi = async (params, measureID, memberID) => {
        await getMultipleInformationApi(objectToQueryString(params), measureID, memberID);
    };

    return (
        <IconButton onClick={handleMultipleInformation}>
            <Icons.Download />
        </IconButton>
    );
};

export default InBodyMultipleInformationDialog;
